export const modularHousesNavItems = {
  model: ' 3D модель',
  options: 'Опції',
};

export const description =
  'Модульні будинки - це незвичайний дизайн і комфортне проживання вашої родини. Затишний Касерес, романтичний Толедо чи динамічна Барселона – цей тип житла легко впишеться в будь-який ландшафт. Ми виготовляємо сучасні, енергоефективні та швидкомонтовані модульні будинки. Ваш будинок, повністю готовий для постійного проживання, врахує всі ваші потреби. Вам надається можливість вибрати варіант з внутрішнім оздобленням під ключ.';